import { render, staticRenderFns } from "./detail-component-multi-person.vue?vue&type=template&id=45de9152&scoped=true"
import script from "./detail-component-multi-person.vue?vue&type=script&lang=ts"
export * from "./detail-component-multi-person.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de9152",
  null
  
)

export default component.exports